import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Stack, Button, Slide } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LockIcon from "@mui/icons-material/Lock";
import BottomSheet from "./../../components/BottomSheet";
import PageHeader from "../../components/PageHeader";
import { UserContext } from "./../../context/userContext";
import ApiService from "./../../services/api-service";
import notifier from "./../../components/Notifier";
import Loader from "./../../components/Loader";
import {
  getErrorString,
  getUserDetail,
  isOwner,
  isOwnerId,
} from "./../../constants/function";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AddPopup from "../../components/AddPopup";
import { Images } from "./../../assets/common";
import { useParams, useHistory } from "react-router-dom";
import MusicCard from "./../../components/MusicCard";
import { addSongAction } from "./../../action/songs";
import { useDispatch } from "react-redux";
import "./index.scss";
import ConfirmPopup from "../../components/ConfirmPopup";
import { useTranslation } from "react-i18next";
export default function Albums() {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { _id } = useParams();
  const history = useHistory();
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(false);
  const { userData } = useContext(UserContext);
  const userDetail = getUserDetail();
  const [open, setOpen] = React.useState(false);
  const [addAlbum, setAddAlbum] = React.useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [title, seTitle] = useState(t("addPopup.title3"));
  const [data, setData] = useState(null);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [editAlbum, setEditAlbum] = React.useState(false)
  const toggleDrawer = (value, id, index) => {
    // setOpen(newOpen);
    if (id) {
      setSelectedAlbum(id);
      setSelectedIndex(index);
    }
    if (value && id) makeAction(value, id, index);
  };

  const makeAction = (key, id, index) => {
    switch (key) {
      case "m21":
        setOpenConfirm(true);
        break;
      case "m31":
        seTitle(t("addPopup.title4"));
        setData(albums[index]);
        setAddAlbum(true);
        setEditAlbum(true);
        break;
      case "m26":
        albums[index].music.forEach((m, i) => {
          dispatch(addSongAction(m, null, true, id));
        });
        break;
      case "m28":
        history.push(`/app/AlbumDetail/${id}`);
        break;
      default:
        break;
    }
  };

  //Delete album
  const deleteAlbum = async (id, index) => {
    try {
      setOpenConfirm(false);
      setLoading(true);
      const response = await ApiService.DELETE_ALBUM(id);
      const tempAlbum = albums;
      tempAlbum.splice(index, 1);
      setAlbums([...tempAlbum]);

      setLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userDetail) {
      getMyAlbums(_id ? _id : userDetail["_id"]);
    }
  }, []);
  const getMyAlbums = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.MY_ALBUM(`${_id}`);
      setLoading(false);
      setAlbums([...response["result"]]);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const handleClosePopup = (e, close, name) => {
    setAddAlbum(close);
    if (e && !data) {
      setAlbums([...albums, e]);
    } else if (data && e) {
      setAlbums(albums.map((a, i) =>
        i === selectedIndex ? { ...a, title: e?.title, thumbnailImg: e?.thumbnailImg, isExplicit: e?.isExplicit } : a
      ));
    }
  };

  return (
    <Box className="__my_albums">
      <Box
        className="__main_pading __my_album_container flex-responsive"
        sx={{
          position: "relative",
          flexWrap: "wrap",
          // maxHeight: "100vh",
          // overflow: "scroll",
        }}
      >
        {_id ? null : (
          <Box className="__add_albums _cp">
            {/* <Box
              className="__card__add"
              onClick={() => {
                setData(null);
                setAddAlbum(true);
              }}
            >
              <AddIcon style={{ color: "#999999", fontSize: "50px" }} />
            </Box> */}
            <Box
              className="__card__add _cp"
              sx={{
                border: "2px dashed #999999",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => {
                setData(null);
                setAddAlbum(true);
                setEditAlbum(false);
              }}
            >
              <AddIcon style={{ color: "#999999", fontSize: "50px" }} />
            </Box>
            <Typography className="fs-14">{t("albums.add")}</Typography>
          </Box>
        )}
        {/* <Stack spacing={2} direction="row" gap="20px" className="__album_row"> */}
        {albums &&
          albums.map((album, index) => (
            <MusicCard
              key={album["_id"]}
              name={album["name"]}
              image={
                album["thumbnailImg"] ? album["thumbnailImg"]["filePath"] : null
              }
              music={album}
              isAlbum={true}
              // noActions={true}
              actions={
                _id
                  ? [
                      { key: "m26", action: t("dropMenu.m26") },
                      { key: "m28", action: t("dropMenu.m28") },
                    ]
                  : isOwnerId(album["artist"])
                  ? [
                      { key: "m26", action: t("dropMenu.m26") },
                      { key: "m31", action: t("dropMenu.m31") },
                      { key: "m21", action: t("dropMenu.m21") },
                      { key: "m28", action: t("dropMenu.m28") },
                    ]
                  : []
              }
              toggleMenu={(item) => toggleDrawer(item, album._id, index)}
            />
          ))}
        {/* </Stack> */}
      </Box>
      {/* <BottomSheet
            open={open}
            actions={["Edit Album", "Remove Album"]}
            handleOpen={toggleDrawer}
          /> */}
      {addAlbum ? (
        <AddPopup
          api="album"
          title={title}
          open={addAlbum}
          data={data}
          image={
            data && data["thumbnailImg"] && data["thumbnailImg"]["filePath"]
              ? data["thumbnailImg"]["filePath"]
              : ""
          }
          handleClose={(e, close, name) => handleClosePopup(e, close, name)}
          editAlbum={editAlbum}
        />
      ) : null}
      {loading ? <Loader /> : null}

      {openConfirm && albums.length > 0 ? (
        <ConfirmPopup
          id={selectedId}
          index={selectedIndex}
          message={`${t("confirmPopup.text1")} "${
            albums[selectedIndex]["title"]
          }" album?`}
          open={openConfirm}
          handleClose={(e, id, index) =>
            e ? deleteAlbum(id, index) : setOpenConfirm(false)
          }
        />
      ) : null}
    </Box>
  );
}
